export { defaultViewerOptions, resolveViewerOptions } from './viewerOptions';
export type { ViewerOptions } from './viewerOptions';

/** Persisted UI preference keys. */
export const STORAGE_KEYS = {
  colorMode: 'markdown-viewer:color-mode',
  readingWidth: 'markdown-viewer:reading-width',
  wrapCode: 'markdown-viewer:wrap-code',
} as const;

/** Reading-width presets, in characters-per-line terms. */
export const READING_WIDTHS = {
  narrow: 62,
  comfortable: 78,
  wide: 104,
  full: 0,
} as const;

export type ReadingWidth = keyof typeof READING_WIDTHS;

export const DEFAULT_READING_WIDTH: ReadingWidth = 'comfortable';